import React, { Component } from 'react'

import Button from 'components/Button'

import s from './BillingBankAccountRow.scss'
import sLay from 'styles/modules/layout.scss'

export default class BillingBankAccountRow extends Component {
  render() {
    const { billingAccount, showBillingAddBankAccountFormModal } = this.props
    const editBankAccount = () => showBillingAddBankAccountFormModal({ billingAccount })

    if (billingAccount.bankAccountBsb && billingAccount.bankAccountLast4Digits) {
      return (
        <div className={s.row}>
          <div className={sLay['hide-xs']} style={{ maxWidth: '110px' }}>
            Bank Account
          </div>
          <div>
            {billingAccount.bankAccountBsb} / xxxxx{billingAccount.bankAccountLast4Digits}
          </div>
          <div>
            <Button size="sm" color="tertiary" onClick={editBankAccount} ghost>
              Update
            </Button>
          </div>
        </div>
      )
    }

    return (
      <Button size="sm" color="tertiary" onClick={editBankAccount} ghost>
        Add Bank Account
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingBankAccountRow/BillingBankAccountRow.jsx